var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.schema.settings.backgroundColor], style: _vm.paddingStyles },
    [
      _c("div", { staticClass: "hpc-blocks-container" }, [
        _c(
          "div",
          {
            staticClass: "hpc-blocks",
            class: ["hpc-blocks--block-count-" + _vm.schema.blocks.length]
          },
          _vm._l(_vm.schema.blocks, function(block) {
            return _c(
              "section",
              {
                staticClass: "hpc-blocks__block clip-transition",
                class: [_vm.schema.settings.textAlignment]
              },
              [
                !_vm.$browserDetect.isIE
                  ? _c(
                      "a",
                      {
                        staticClass: "hpc-blocks__image-wrapper",
                        attrs: {
                          href: block.settings.block_link_url,
                          "aria-label": block.settings.block_link_text
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: block.settings.block_image,
                            srcset:
                              _vm.imageCrop(
                                _vm.imageSize(
                                  block.settings.block_image,
                                  "376x"
                                ),
                                "center"
                              ) +
                              " 376w, " +
                              _vm.imageCrop(
                                _vm.imageSize(
                                  block.settings.block_image,
                                  "952x"
                                ),
                                "center"
                              ) +
                              " 952w, " +
                              _vm.imageCrop(
                                _vm.imageSize(
                                  block.settings.block_image,
                                  "1312x"
                                ),
                                "center"
                              ) +
                              " 1312w",
                            alt: block.alt || block.settings.block_header,
                            role: "presentation"
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            class:
                              _vm.$store.state.badgeColorMap[
                                block.settings.block_badge
                              ]
                          },
                          [_vm._v(_vm._s(block.settings.block_badge))]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.$browserDetect.isIE
                  ? _c(
                      "a",
                      {
                        staticClass: "hpc-blocks__image-wrapper ie",
                        style:
                          "backgroundImage: url(" +
                          block.settings.block_image +
                          ")",
                        attrs: {
                          href: block.settings.block_link_url,
                          "aria-label": block.settings.block_link_text,
                          alt: block.alt,
                          role: "presentation"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            class:
                              _vm.$store.state.badgeColorMap[
                                block.settings.block_badge
                              ]
                          },
                          [_vm._v(_vm._s(block.settings.block_badge))]
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row hpc-blocks__block-content" },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "h3-mobile col-12-sm hpc-blocks__header",
                        class: [
                          _vm.schema.settings.textColor,
                          _vm.headingTagMap[_vm.schema.blocks.length]
                        ]
                      },
                      [_vm._v(_vm._s(block.settings.block_header))]
                    ),
                    _c("div", {
                      staticClass:
                        "col-12-sm client-generated body-sm-mobile body-md-tablet-up",
                      class: [_vm.schema.settings.textColor],
                      domProps: {
                        innerHTML: _vm._s(block.settings.block_description)
                      }
                    }),
                    block.settings.block_link_url &&
                    block.settings.block_link_text
                      ? _c(
                          "v-link",
                          {
                            attrs: {
                              primary: "",
                              href: block.settings.block_link_url
                            }
                          },
                          [_vm._v(_vm._s(block.settings.block_link_text))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }